export default __webpack_public_path__ + "static/media/atar_logo.bf85b4c4.png";